import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { configureAuth } from './services/auth';
import './i18n/config';
import './styles/global.css';

// Initialize Amplify auth before rendering
configureAuth();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Remove inline app-shell once React has painted
requestAnimationFrame(() => {
  const shell = document.getElementById('app-shell');
  if (shell) shell.remove();
});
